import { render, staticRenderFns } from "./ProtocolFrame.vue?vue&type=template&id=17662455&scoped=true"
import script from "./ProtocolFrame.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProtocolFrame.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProtocolFrame.vue?vue&type=style&index=0&id=17662455&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17662455",
  null
  
)

export default component.exports